var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.quoteFreight.logistic_provider.delivery_methods.length > 0
    ? _c("div", [
        _c(
          "h2",
          {
            staticClass:
              "subtitle has-text-weight-bold has-text-primary is-size-4"
          },
          [
            _vm._v(
              "\n      Opções de Envio (" +
                _vm._s(
                  _vm.quoteFreight.logistic_provider.delivery_methods.length
                ) +
                ")\n  "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "columns sc-delivery-options-column" },
          _vm._l(_vm.quoteFreight.logistic_provider.delivery_methods, function(
            deliveryMethod,
            deliveryMethodKey
          ) {
            return _c(
              "div",
              { key: deliveryMethodKey, staticClass: "column is-4" },
              [
                _c(
                  "sc-card",
                  [
                    _c(
                      "template",
                      { attrs: { slot: "header" }, slot: "header" },
                      [
                        _c(
                          "p",
                          {
                            staticClass:
                              "has-text-primary is-size-6 card-header-title"
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(deliveryMethod.name) +
                                "\n          "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("template", { attrs: { slot: "body" }, slot: "body" }, [
                      _c("div", { staticClass: "columns" }, [
                        _c("div", { staticClass: "column" }, [
                          deliveryMethod.name
                            ? _c("p", { staticClass: "heading" }, [
                                _c("strong", [_vm._v("Método de envio:")]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(deliveryMethod.name))
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          deliveryMethod.description
                            ? _c("p", { staticClass: "heading" }, [
                                _c("strong", [_vm._v("Nome exibido:")]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(deliveryMethod.description))
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          deliveryMethod.type.label
                            ? _c("p", { staticClass: "heading" }, [
                                _c("strong", [_vm._v("Tipo de Método:")]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(deliveryMethod.type.label))
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("p", { staticClass: "heading" }, [
                            _c("strong", [_vm._v("Frete exibido:")]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("currency")(
                                    deliveryMethod.final_shipping_cost
                                  )
                                )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          deliveryMethod.delivery_estimate_minutes ||
                          deliveryMethod.delivery_estimate_minutes === 0 ||
                          deliveryMethod.delivery_estimate_business_days ||
                            deliveryMethod.delivery_estimate_business_days === 0
                            ? _c("p", { staticClass: "heading" }, [
                                _c("strong", [_vm._v("Prazo de entrega:")]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      deliveryMethod.delivery_estimate_minutes ||
                                        deliveryMethod.delivery_estimate_minutes ===
                                          0
                                        ? deliveryMethod.delivery_estimate_minutes +
                                            " minuto(s)"
                                        : deliveryMethod.delivery_estimate_business_days +
                                            " dia(s)"
                                    )
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          deliveryMethod.delivery_estimate_date_minutes_iso
                            ? _c("p", { staticClass: "heading" }, [
                                _c("strong", [
                                  _vm._v("Data prevista da entrega:")
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm
                                        .Moment(
                                          deliveryMethod.delivery_estimate_date_minutes_iso
                                        )
                                        .format("L") +
                                        " ÀS " +
                                        _vm
                                          .Moment(
                                            deliveryMethod.delivery_estimate_date_minutes_iso
                                          )
                                          .format("LT")
                                    )
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          deliveryMethod.cost
                            ? _c("p", { staticClass: "heading" }, [
                                _c("strong", [_vm._v("Custo de envio:")]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("currency")(deliveryMethod.cost)
                                    )
                                  )
                                ])
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "column is-narrow" }, [
                          _c("figure", { staticClass: "image is-128x128" }, [
                            _c("img", {
                              attrs: {
                                src: deliveryMethod.logo_url,
                                alt: deliveryMethod.name
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _vm.quoteFreight.id
                            ? _c(
                                "a",
                                {
                                  staticClass: "button is-primary",
                                  attrs: {
                                    href:
                                      "/ng#/recote/" +
                                      _vm.quoteFreight.id +
                                      "/" +
                                      deliveryMethod.id +
                                      "?msg=false&url=" +
                                      _vm.backUrl +
                                      "&logisticContractMode=" +
                                      _vm.logistic_contract_mode +
                                      "&reverse=" +
                                      _vm.shipment_type,
                                    target: "_blank"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                      Cotação Detalhada\n                  "
                                  )
                                ]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "button is-primary",
                                  attrs: { href: "javascript:void(0)" },
                                  on: {
                                    click: function($event) {
                                      _vm.getDetail(deliveryMethod)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                      Cotação Detalhada\n                  "
                                  )
                                ]
                              )
                        ])
                      ])
                    ])
                  ],
                  2
                )
              ],
              1
            )
          })
        ),
        _vm._v(" "),
        _c("hr")
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61b30096", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61b30096","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-quote/features/freight-quote/components/sc-delivery-options/ScDeliveryOptions.vue
// module id = null
// module chunks = 